// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var React       = require("react");
var Subtitle    = require("../components/Subtitle");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./LoginScreen.css')));

((require('firebaseui/dist/firebaseui.css')));

var component = ReasonReact.statelessComponent("LoginScreen");

var authContainerId = "firebase-auth";

var authContainer = "#firebase-auth";

function make() {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return React.createElement("div", {
                  className: "LoginScreen"
                }, React.createElement("header", undefined, ReasonReact.element(/* None */0, /* None */0, Subtitle.make("Login to use Mam", /* array */[]))), React.createElement("div", {
                      id: authContainerId
                    }));
    });
  return newrecord;
}

exports.component       = component;
exports.authContainerId = authContainerId;
exports.authContainer   = authContainer;
exports.make            = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/screen/LoginScreen.re
// module id = 250
// module chunks = 0